import styled from 'styled-components';
import { Colors, TextCss } from 'styles';
import { transparentize } from 'color2k';

type ToolbarButtonProps = {
  type?: 'button' | 'submit' | 'reset';
  height?: string;
  hasLabels?: boolean;
  toolbarEditOn?: boolean;
  ['data-testid']?: string;
  ['data-analytics-name']?: string;
  css?: string;
  selected?: boolean;
  disabled?: boolean;
};

export const ToolbarButton = styled.button.attrs<ToolbarButtonProps>((props) => ({
  type: props.type ?? 'button',
}))<ToolbarButtonProps>`
  app-region: no-drag;

  height: ${(props) => (props.height != null ? props.height : '6rem')};
  width: 48px;
  border: inherit;
  background: ${(props) =>
    props.disabled === true
      ? Colors.darkBackground
      : props.selected === true
        ? Colors.blue3
        : 'inherit'};
  color: ${(props) => (props.disabled === true ? Colors.gray7 : Colors.gray10)};
  padding: 0;
  cursor: ${(props) => (props.disabled === true ? 'not-allowed' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${TextCss.small}
  text-align: center;
  margin: ${(props) => (props.hasLabels === true ? '0.2rem 0.5rem' : '0')};
  opacity: 1;

  &:hover {
    background-color: ${(props) =>
      props.toolbarEditOn === true || props.disabled === true
        ? Colors.darkBackground
        : Colors.gray3};
    border-color: ${(props) =>
      props.toolbarEditOn === true || props.disabled === true
        ? 'inherit'
        : transparentize(Colors.gray10, 0.63)};
  }
`;
